import { getParameterByName } from './helpers'

export const checkForAppUid = () => {
  const appUid = getParameterByName('code')
  if (appUid) {
    window.localStorage.setItem('app_uid', appUid)
  }
}
